import { SortEnum, UserWorkspaceStatusEnum, useWorkspaceMembersV2Query } from '@/types/generated/graphql';
import { SelectMemberTypeEnum } from '@modules/teams/teams.types';
import { MEMBERS_PAGE_SIZE } from '@modules/conversations/features/all-members-conversation/all-members-conversation.constants';
import { useMemo } from 'react';

export function useAllMembersList() {
  const { data, loading } = useWorkspaceMembersV2Query({
    variables: {
      limit: MEMBERS_PAGE_SIZE,
      order: SelectMemberTypeEnum.createdAt,
      sort: SortEnum.ASC,
      status: UserWorkspaceStatusEnum.accepted,
    },
  });

  const members = useMemo(
    () => (data?.workspaceMembersV2?.data ?? []).filter((member) => !!member?.id),
    [data?.workspaceMembersV2?.data]
  );

  return {
    members,
    memberCount: members.length,
    onlineCount: members.filter((member) => member?.userOnlineManagement?.isActive).length,
    loading,
  };
}
